module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/hero_mob-0b4970b213607f1dbe59aefe0c985abf.jpg";